import { api } from "./api";

export interface FilaTreinamento {
  id: string;
  id_militar: string;
  militar: {
    id: string;
    nick: string;
    patente?: {
      abreviacao: string;
      nome: string;
    };
  };
  data_hora_entrada: string;
  data_hora_saida: string | null;
  status: "ativo" | "indisponivel" | "retirado";
  motivo_retirada: "treinamento_enviado" | "offline_ausente" | null;
  id_militar_retirou: string | null;
  militar_retirou?: {
    id: string;
    nick: string;
    patente?: {
      abreviacao: string;
    };
  };
  created_at: string;
  updated_at: string;
}

export interface FilaResponsavel {
  id: string;
  id_militar: string;
  militar: {
    id: string;
    nick: string;
    patente?: {
      abreviacao: string;
      nome: string;
    };
  };
  data_hora_inicio: string;
  data_hora_termino: string | null;
  status: "ativo" | "pausado" | "retomou" | "finalizado" | "passou";
  data_hora_pausa: string | null;
  tempo_pausado_segundos: number;
  created_at: string;
  updated_at: string;
}

export const filasTreinamentoService = {
  async listarAtivos(): Promise<FilaTreinamento[]> {
    const response = await api.get("/filas-treinamento");
    return response.data;
  },

  async entrar(): Promise<FilaTreinamento> {
    const response = await api.post("/filas-treinamento/entrar");
    return response.data;
  },

  async marcarIndisponivel(id: string): Promise<FilaTreinamento> {
    const response = await api.patch(`/filas-treinamento/${id}/indisponivel`);
    return response.data;
  },

  async marcarDisponivel(id: string): Promise<FilaTreinamento> {
    const response = await api.patch(`/filas-treinamento/${id}/disponivel`);
    return response.data;
  },

  async retirar(id: string, motivo: "treinamento_enviado" | "offline_ausente"): Promise<void> {
    await api.delete(`/filas-treinamento/${id}`, {
      data: { motivo },
    });
  },
};

export const filasResponsaveisService = {
  async getAtual(): Promise<FilaResponsavel | null> {
    const response = await api.get("/filas-responsaveis/atual");
    return response.data;
  },

  async iniciar(): Promise<FilaResponsavel> {
    const response = await api.post("/filas-responsaveis/iniciar");
    return response.data;
  },

  async pegar(): Promise<FilaResponsavel> {
    const response = await api.post("/filas-responsaveis/pegar");
    return response.data;
  },

  async pausar(): Promise<FilaResponsavel> {
    const response = await api.patch("/filas-responsaveis/pausar");
    return response.data;
  },

  async retomar(): Promise<FilaResponsavel> {
    const response = await api.patch("/filas-responsaveis/retomar");
    return response.data;
  },

  async finalizar(): Promise<void> {
    await api.delete("/filas-responsaveis/finalizar");
  },
};
